import { API, authClient } from "../index";

export const postCreateCheckoutSession = async (obj) => {
  return authClient().post(`${API}/stripe/create-checkout-session`, obj);
};

export const getSessionStatus = async (sessionId) => {
  return authClient().get(`${API}/stripe/${sessionId}`);
};
